import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <Container>
        <SectionHeading
          align="center"
          eyebrow="Cómo trabajamos"
          title="Solicitar tu servicio es muy simple"
          description="Un proceso claro de principio a fin para que tu operación salga sin contratiempos."
        />

        <div className="relative mt-12">
          <div className="absolute left-6 top-0 hidden h-full w-px bg-background-200 lg:left-0 lg:top-9 lg:h-px lg:w-full lg:bg-background-200"></div>
          <ol className="relative grid grid-cols-1 gap-8 lg:grid-cols-4 lg:gap-6">
            {processSteps.map((step, index) => (
              <li key={step.id} className="relative flex gap-4 lg:flex-col lg:gap-0">
                <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-background-200 bg-background-50 text-accent-600 lg:mb-5">
                  <i className={`${step.icono} text-xl leading-none`} aria-hidden="true"></i>
                  <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary-500 text-[10px] font-label font-bold text-background-50 dark:text-foreground-950">
                    {index + 1}
                  </span>
                </div>
                <div className="pt-1 lg:pt-0">
                  <h3 className="text-base font-heading font-semibold text-foreground-950">
                    {step.titulo}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.descripcion}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </Container>
    </section>
  );
}